const SUFFIXES = ['Bytes', 'KB', 'MB', 'GB'];
const fmt = new Intl.NumberFormat('default', {
  maximumFractionDigits: 2
});
export default function formatBytes(size) {
  if (size == null) return '--';
  let sizeBig = 0n;
  try {
    // Multiply by 100 to later get fractional digits
    sizeBig = BigInt(size) * 100n;
  } catch {
    // Swallow error to prevent crashing the glimmer renderer
    return '--';
  }
  let suffixIdx = 0;
  while (sizeBig > 100_000n && suffixIdx < SUFFIXES.length - 1) {
    sizeBig /= 1000n;
    suffixIdx++;
  }

  // Handle case where after division the number may still be too big to convert to float64
  if (sizeBig > Number.MAX_SAFE_INTEGER) {
    return 'Infinity';
  }
  return `${fmt.format(Number(sizeBig) / 100)} ${SUFFIXES[suffixIdx]}`;
}